import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(companyConfigurationRoute);

    /** @ngInject */
    function companyConfigurationRoute($stateProvider) {
        $stateProvider.state('company_employee.configuration', {
            url: '/panel',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/company_configuration/company-configuration.html'),
            controller: 'CompanyConfigurationController',
            controllerAs: 'CompanyConfigurationCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/company_configuration/company-configuration.route.ts